// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"Checkbox_checkboxWrapper__adW+i","checkbox":"Checkbox_checkbox__hIaSM","customCheckbox":"Checkbox_customCheckbox__3vMvQ"};